import { render } from "./TopInstrumentsMenu.vue?vue&type=template&id=5e00f17a&scoped=true"
import script from "./TopInstrumentsMenu.vue?vue&type=script&lang=js"
export * from "./TopInstrumentsMenu.vue?vue&type=script&lang=js"

import "./TopInstrumentsMenu.vue?vue&type=style&index=0&id=5e00f17a&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e00f17a"]])

export default __exports__